import React, { useState } from 'react';
import leaderboardIcon from '../assets/leaderboard_icon.png';
import LeaderboardModal from './LeaderboardModal';

export default function LeaderboardButton() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        style={{
          position: 'absolute',
          top: 124,
          right: 0,
          zIndex: 1200,
          border: 'none',
          background: 'transparent',
          cursor: 'pointer',
        }}
      >
        <img src={leaderboardIcon} alt="Leaderboard" style={{ width: 70, height: 70 }} />
      </button>
      <LeaderboardModal open={open} onClose={() => setOpen(false)} />
    </>
  );
}
